import LegalPage from '../shared/LegalPage';
import { business } from '../content';
import { useLanguage } from '../language/LanguageContext';
import { fillTemplate } from '../language/translations';
import { Link } from 'react-router-dom';

function DeleteAccount() {
  const { t } = useLanguage();
  const values = {
    appName: business.appName
  };

  return (
    <LegalPage
      title={t.deleteAccount.title}
      intro={fillTemplate(t.deleteAccount.intro, values)}
    >
      <section className="support-box">
        <h2>{t.deleteAccount.requestTitle}</h2>
        <p>{t.deleteAccount.requestText}</p>
        <Link className="button primary" to="/delete-account/request">
          {t.deleteAccount.requestCta}
        </Link>
      </section>

      <section>
        <h2>{t.deleteAccount.includeTitle}</h2>
        <ul>
          {t.deleteAccount.include.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section>
        <h2>{t.deleteAccount.nextTitle}</h2>
        <p>{t.deleteAccount.nextText}</p>
      </section>

      <section>
        <h2>{t.deleteAccount.timeTitle}</h2>
        <p>{t.deleteAccount.timeText}</p>
      </section>
    </LegalPage>
  );
}

export default DeleteAccount;
